module.exports = __webpack_public_path__ + "img/funtoon_icon.777cea1f.svg";